import {mysqlDateFormat} from './dateHelpers'

// export const pluckColumns = ['action_delete', 'action_edit', 'createdAt', 'updatedAt', 'deletedAt', 'removalDate', 'dateApproved', 'id']
// export const pluckColumns = ['action_delete', 'action_edit', 'createdAt', 'updatedAt', 'deletedAt', 'id']
export const pluckColumns = ['action_delete', 'action_edit', 'deletedAt', 'id']

export const normalizeOption = (model, labelField, idField = 'id', subtitleField = null) => {
  if (typeof idField !== 'string') {
    idField = 'id'
  }
  return {
    id: model[idField],
    value: model[idField],
    label: model[labelField],
    subtitle: subtitleField ? model[subtitleField] : ''
  }
}

export const objectChanges = (savedModel, newModel) => {
  let diff = Object.keys(newModel).reduce((diff, key) => {
    if (savedModel[key] === newModel[key]) return diff
    return {
      ...diff,
      [key]: newModel[key]
    }
  }, {})
  return diff
}

export const normalizeValue = (column, value) => {
  // console.log('normalizeValue', column, value)
  switch (column.type) {
    case 'boolean':
      if (value === 1 || value === 0 || value === true || value === false) {
        // console.log('bool val', value)
        return !!value
      }
      // if (column.defaultValue) {
      // console.log('bool val', column.defaultValue)
      if (column.defaultValue === 1 || column.defaultValue === 0 || column.defaultValue === true || column.defaultValue === false) {
        return !!column.defaultValue
      }
      // }
      return null
    case 'date':
      if (value) {
        return new Date(value)
      }
      if (column.defaultValue) {
        return new Date(column.defaultValue)
      }
      return null
    // return value ? new Date(value) : new Date()
    case 'number':
      // console.log('normalize number Value', value)
      if (value === '' || !value) {
        return null
      } else {
        if (value || value >= 0) {
          const strValue = value.toString()
          if (strValue.indexOf('.')) {
            // console.log('parseFloat(value)', parseFloat(value))
            return parseFloat(value)
          }
          // console.log('value', value)
          return parseInt(value)
        }
        if (column.defaultValue || column.defaultValue >= 0) {
          const strValue = column.defaultValue.toString()
          if (strValue.indexOf('.')) {
            // console.log('parseFloat(column.defaultValue', parseFloat(column.defaultValue))
            return parseFloat(column.defaultValue)
          }
          // console.log('parseInt(column.defaultValue)', parseInt(column.defaultValue))
          return parseInt(column.defaultValue)
        }
      }
      // console.log('null')
      return null // was 0, but I think this is annoying
    // return 0
    default:
      if (value) {
        // console.log('default value', value)
        return value.toString()
      }
      if (column.defaultValue) {
        // console.log('default column.defaultValue', column.defaultValue)
        return column.defaultValue.toString()
      }
      return ''
  }
}

export const normalizeModel = (columns, model, state) => {
  let pluckColumnsEnhanced = pluckColumns
  if (state && state.fakeColumns) {
    // console.log('normalizeModel state', state)
    // console.log(Object.keys(state.fakeColumns))
    // let addArray = Object.keys(state.fakeColumns)
    pluckColumnsEnhanced = pluckColumns.concat(Object.keys(state.fakeColumns))
  }
  // console.log('normalizeModel columns', columns, 'model', model, 'state', state)
  // console.log('fakeColumns', pluckColumnsEnhanced)
  // const col = columns
  return columns
    .filter(col => pluckColumnsEnhanced.indexOf(col.field) === -1)
    .reduce((obj, col) => {
      // if (!model || model.length < 1) {
      //   model = obj
      // }
      let value = ''
      if (col.relation && col.relation.type === 'many') {
        value = []
        if (col.component.is === 'q-select') {
          obj[col.field] = Array.isArray(model[col.field]) ? model[col.field].map(m => m[col.relation.fk]) : []
          return obj
        }
        if (model[col.field] && model[col.field].length) {
          value = model[col.field].map(m => normalizeOption(m, col.relation.label, col.relation.fk))
        }
        obj[col.field] = value
        return obj
      }
      if (col.relation && col.relation.type === 'one') {
        value = ''
        if (model[col.field]) {
          // console.log('--- normalize --')
          // console.log('model[col.field]', model[col.field])
          // console.log('col.relation.label', col.relation.label)
          // console.log('col.relation.fk', col.relation.fk)
          value = normalizeOption(model[col.field], col.relation.label)
        }
        obj[col.field] = value.id ? value.id : value
        return obj
      }
      if (model[col.field] !== undefined) {
        value = model[col.field]
      }
      // value = model[col.field]
      if (!value || !value >= 0) {
        if (col.defaultValue || col.defaultValue >= 0) {
          value = col.defaultValue
        }
      }
      obj[col.field] = normalizeValue(col, value)
      // // console.log('normalizeModel End', obj)
      // console.log('col.field', col.field)
      // console.log('model[col.field]', model[col.field])
      // console.log('obj[col.field]', obj[col.field])
      // console.log('col', col)
      // console.log('obj', obj)
      // console.log('model', model)
      // console.log('normalizeModel value:', value)
      // console.log('=======================')
      return obj
    }, {})
  // console.log('col', col)
  // return col
}

export const normalizePost = async (model, columns = [], modelId = null, type = 'new', parentId, parentResource) => {
  // console.log('>> ---- NORMALIZE POST ------- << ')
  // console.log('model ', model, 'columns', columns, 'modelId', modelId, 'type', type, 'parentId', parentId)
  // keys to not be included
  return columns.filter(column => {
    // console.log('filter', column.field)
    if (column.noSave) {
      return false
    }
    // console.log('filter noSave', column.field)

    // -- types: ['file', 'image']
    if (column.type === 'file' || column.type === 'image') {
      return false
    }
    // console.log('filter file', column.field)

    // -- relations (many)
    if (column.relation) {
      if (column.relation.type === 'many' || column.relation.type === 'polymorphic') {
        return false
      }
    }
    // console.log('filter relation', column.field)
    // -- specific default keys
    if (pluckColumns.indexOf(column.field) !== -1) {
      // -- keep id field if this is a post
      // console.log('column', column)
      // console.log('column.field', column.field)
      // console.log('modelId', modelId)
      return modelId !== null
      // return column.field === 'id' && modelId !== null
    }
    // console.log('filter pluck', column.field)

    // -- this column can be used in the post
    return true
  }).reduce((obj, column) => {
    // -- define key as column.field
    // console.log('======= NEW REDUCE ========')
    const key = column.field
    let value = model[key]
    // console.log('value', value, 'key', key)
    // if ((!value || value === '') && parentId) {
    //   value = {id: parentId}
    // }
    if (key === 'sponsorshipTitle') {
      value = {id: parentId}
    }
    // -- handle DATE
    if (column && column.type === 'date' && value !== undefined && value !== null) {
      // console.log('>> ---- NORMALIZE DATE ------- << ')
      const newDate = mysqlDateFormat(value)
      // console.log('newDate', newDate)
      obj[key] = newDate
      return obj
    }

    const relation = column.relation
    // console.log('column', column, 'obj', obj, 'key', key, 'model', model, 'value', value)
    // if (relation && relation.localKey) {
    //   console.log('relation', relation, relation.localKey.slice(0, -2))
    // }

    // if (relation && relation.localKey && key === relation.localKey.slice(0, -2) && parentId) {
    if (relation && parentResource && parentId && key === parentResource) {
      // console.log('Remove relation field', key)
      value = {id: parentId}
      // return false
    }
    // -- handle OBJECT (relation.type === 'one')
    if ((relation && relation.type === 'one') || (value !== null && value !== undefined && typeof value === 'object')) {
      // console.log('>> ---- NORMALIZE OBJECT ------- << ')
      // console.log(`>> Field: ${key}`)
      // console.log(`>> Column:`, column)
      // console.log(`>> value:`, value)
      if (value && value.id) {
        // -- localKey for hasOne or belongsTo
        // console.log(`>> value: 2`, value)
        if (column && column.relation && column.relation.localKey) {
          // TODO: THIS WAS ADDING ID TO COMPANY ON SAVE AFTER A MEMBERSHIP WAS CREATED. IS THIS NEEDED?
          // THIS IS NEEDED FOR type === one
          obj[column.relation.localKey] = value.id
          // console.log(`--- Assigning localKey 1: ${column.relation.localKey} ${value.id}`)
          return obj
        } else {
          const relationKeyNameGuess = `${key}Id`
          // -- no local key defined
          // console.log('--- WARNING: Column Relation should contain a localKey')
          // console.log(`----- Guessing key name: ${relationKeyNameGuess}`)
          obj[relationKeyNameGuess] = value.id
          return obj
        }
      } else {
        if (type === 'update') {
          if (column && column.relation && column.relation.localKey) {
            // Need this for new records but messes up double edits on existing records as the localKey gets removed and that is needed for an update
            // obj[column.relation.localKey] = null
            // obj[key] = null
            // console.log(`--- Assigning localKey update 2: ${column.relation.localKey} null`)
            return obj
          } else {
            const relationKeyNameGuess = `${key}Id`
            // -- no local key defined
            // console.log('--- WARNING: Column Relation should contain a localKey')
            // console.log(`----- Guessing key name: ${relationKeyNameGuess}`)
            obj[relationKeyNameGuess] = null
            obj[key] = null
            return obj
          }
        } else {
          if (column && column.relation && column.relation.localKey) {
            // Need this for new records but messes up double edits on existing records as the localKey gets removed and that is needed for an update
            obj[column.relation.localKey] = null
            obj[key] = null
            // console.log(`--- Assigning localKey no update 2: ${column.relation.localKey} null`)
            return obj
          } else {
            const relationKeyNameGuess = `${key}Id`
            // -- no local key defined
            // console.log('--- WARNING: Column Relation should contain a localKey')
            // console.log(`----- Guessing key name: ${relationKeyNameGuess}`)
            obj[relationKeyNameGuess] = null
            obj[key] = null
            return obj
          }
        }
      }
      // obj[key] = null
      // return obj
    }

    // -- handle array type
    if (Array.isArray(value)) {
      return obj
    }

    if (value === undefined || value === null) {
      obj[key] = null
      return obj
    }
    // -- handle normal attribute
    obj[key] = value

    return obj
  }, {})
  // .filter(column => {
  //   console.log('column filter', column)
  //   // if (column.relation && column.relation.localKey && column.field === column.relation.localKey.slice(0, -2)) {
  //   //   console.log('Remove relation field', column.field)
  //   //   return false
  //   // }
  // })
  // return normalized
}
